import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";


const Main = () => {
    const location = useLocation();
    return (
        // <>
        //     <Navbar></Navbar>
        //     <Outlet></Outlet>
        //     {
        //         location.pathname !== "/login" && location.pathname !== "/signup" && <Footer></Footer>
        //     }

        // </>


        <div>
            <main className='flex'>
                <Sidebar />
                <div className='w-full'>
                    <Navbar />
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default Main;